import { SelectProps, TableCellProps } from "@mui/material";
import { MRT_Column, MRT_TableInstance } from "material-react-table";
import {
  PAGE_SIZE_QUERY_ALL_VALUE,
  PAGE_SIZE_QUERY_NAME_ALL,
} from "@techzyapp/ui-lib";

export const columnPinning = {
  right: ["mrt-row-actions"],
};

export const selectProps: SelectProps = {
  variant: "outlined",
  className: "MuiSelectBase-root MuiTextField-withIcon",
  sx: { width: "68px", height: "42px" },
};

export const rowsPerPageOptions = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "200", value: 200 },
  { label: PAGE_SIZE_QUERY_NAME_ALL, value: PAGE_SIZE_QUERY_ALL_VALUE },
];

export const rowsPerPageOptionsWithoutAll = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "200", value: 200 },
];

export const muiCircularProgressProps = {
  className: "MuiCircularProgress-colorPrimary MuiCircularProgress-sizeXl",
};

export const muiTableBodyCellProps = <T extends object>({
  column,
}: {
  column: MRT_Column<T>;
}): TableCellProps => {
  let className = "";
  if (column.id === "mrt-row-drag") {
    className = "MuiTableCell-drag";
  } else if (column.id === "mrt-row-actions") {
    className = "MuiTableCell-actions";
  }
  return { className };
};

export const muiTableHeadCellProps = <T extends object>({
  column,
}: {
  column: MRT_Column<T>;
  table: MRT_TableInstance<T>;
}): TableCellProps => {
  let className = "";

  if (column.id === "mrt-row-drag") {
    className = "MuiTableCell-drag";
  } else if (column.id === "mrt-row-actions") {
    className = "MuiTableCell-actions";
  }

  return { className };
};

export const renderEmptyRowsFallback = () => (
  <div className="MuiTable-NoData">No results found</div>
);
